import { render, staticRenderFns } from "./SitBlockCard.vue?vue&type=template&id=608ad19b&"
import script from "./SitBlockCard.vue?vue&type=script&lang=js&"
export * from "./SitBlockCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports